import React from 'react';
import { DialogBody, DialogFooter } from '#components/Elements/Dialog/Dialog';
import Button from '#components/Elements/Button/Button';
import { FormattedMessage } from 'react-intl';
import styles from './PasskeyOfferModal.scss';

export default function PasskeyOfferModal({ visible, onConfirm, onCancel }) {
  if (!visible) {
    return <></>;
  }

  return (
    <>
      <DialogBody>
        <div className={styles.passkeyHeader}>
          <FormattedMessage defaultMessage="Enable Passkey" />
        </div>
        <div className={styles.passkeyBody}>
          <FormattedMessage defaultMessage="Would you like to skip MFA on this device in the future by registering a passkey?" />
        </div>
      </DialogBody>
      <DialogFooter>
        <Button color="secondary" onClick={onCancel}>
          <FormattedMessage defaultMessage="No, thanks" />
        </Button>
        <Button color="primary" onClick={onConfirm}>
          <FormattedMessage defaultMessage="Yes, register" />
        </Button>
      </DialogFooter>
    </>
  );
}
